document.addEventListener('click', event => {
  const element = event.target

  if (element.dataset.behavior &&
      element.dataset.behavior.includes('calculate-minimum-qualifying-income')) {
    const mortgagePrincipalInterest = parseFloat(document.querySelector('[name="mortgage-principal-interest"]').value.replace(/[$,]+/g, ''))
    const propertyTax = parseFloat(document.querySelector('[name="property-tax"]').value.replace(/[$,]+/g, ''))
    const homeInsurance = parseFloat(document.querySelector('[name="home-insurance"]').value.replace(/[$,]+/g, ''))
    const otherLoanPayments = parseFloat(document.querySelector('[name="other-loan-payments"]').value.replace(/[$,]+/g, ''))

    const piti = mortgagePrincipalInterest + propertyTax + homeInsurance
    const monthlyMinimumQualifyingIncome = window.Calculator.getMonthlyRequiredIncome(piti, otherLoanPayments)

    const annualMinimumQualifyingIncome = Math.trunc(monthlyMinimumQualifyingIncome * 12)
    const unformattedResult = annualMinimumQualifyingIncome.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    const result = `$ ${unformattedResult}`

    if (element.closest('form').checkValidity()) {
      document.getElementById('mortgage-loan-qualifying-result').innerHTML = result
    }
  }
}, false)
